class TermsAndConditions extends HTMLElement {
  constructor() {
    super();
  }

  get checkbox() {
    return this.querySelector('input[type="checkbox"]');
  }

  get atcButton() {
    return this.closest('.product__info-container').querySelector('.product-form__buttons [name="add"]');
  }

  get error() {
    return this.querySelector('[data-error]');
  }

  connectedCallback() {
    this.checkHandler = this.handleCheck.bind(this);
    this.checkbox.addEventListener('change', this.checkHandler);

    this.atcClickHandler = this.handleAtcClick.bind(this);
    this.atcButton.addEventListener('click', this.atcClickHandler);

    const checked = this.checkbox.checked;
    this.atcButton.toggleAttribute('data-disabled', !checked);
  }

  disconnectedCallback() {
    this.checkbox.removeEventListener('change', this.checkHandler);
    this.atcButton.removeEventListener('click', this.atcClickHandler);
  }

  handleAtcClick(e) {
    if(!this.atcButton.hasAttribute('data-disabled')) return true;
    e.preventDefault();
    e.stopPropagation();
    this.error.classList.remove('tw-hidden');
  }

  handleCheck(e) {
    const checkbox = e.target;
    if(!checkbox) return;
    this.error.classList.add('tw-hidden');
    const checked = checkbox.checked;
    this.atcButton.toggleAttribute('data-disabled', !checked);
  }
}

if (!customElements.get('terms-and-conditions')) customElements.define('terms-and-conditions', TermsAndConditions);
